<template>
    <div class="right-click-wrapper" style="width: 100%;">
        <!-- 插槽用于放置原有的div内容 -->
        <div class="target-wrapper" style="width: 100%;" @contextmenu.prevent="showMenu($event)" @click="hideMenu">
            <slot />
        </div>
        <!-- 右键菜单 -->
        <div v-if="visible" class="context-menu" :style="{
        top: `${menuTop}px`,
        left: `${menuLeft}px`,
        minWidth: `${minWidth}px`
      }" @mouseleave="handleMouseLeave" @contextmenu.prevent @click.stop>
            <ul style="padding: 0px;margin:0px">
                <li v-for="(item, index) in validItems" :key="index" :class="{
            'menu-item': true,
            'disabled': item.disabled,
            'divider': item.type === 'divider'
          }" @click.stop="handleItemClick(item)">
                    <template v-if="item.type !== 'divider'">
                        <span>{{ item.label }}</span>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
// 创建全局菜单管理器，确保同一时间只有一个菜单显示
const menuManager = {
  menus: [],
  add(menu) {
    this.menus.push(menu);
  },
  remove(menu) {
    this.menus = this.menus.filter(m => m !== menu);
  },
  closeAllExcept(exceptMenu) {
    this.menus.forEach(menu => {
      if (menu !== exceptMenu) {
        menu.hideMenu();
      }
    });
  }
};

export default {
    name: 'RightClickWrapper',
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
        minWidth: {
            type: Number,
            default: 100
        },
        closeOnMouseLeave: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        validItems() {
            return this.items.filter(item => {
                if (!item || typeof item !== 'object') return false;
                if (item.type === 'divider') return true;
                return item.label !== undefined;
            });
        }
    },
    data() {
        return {
            visible: false,
            menuTop: 0,
            menuLeft: 0
        };
    },
    mounted() {
        // 将当前菜单实例添加到全局管理器
        menuManager.add(this);
        document.addEventListener('click', this.hideMenu);
    },
    beforeUnmount() {
        // 从全局管理器移除当前实例
        menuManager.remove(this);
        document.removeEventListener('click', this.hideMenu);
    },
    methods: {
        showMenu(event) {
            // 显示当前菜单前，关闭所有其他菜单
            menuManager.closeAllExcept(this);
            
            const { clientX, clientY } = event;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;

            let left = clientX;
            let top = clientY;

            if (left + this.minWidth > windowWidth) {
                left = windowWidth - this.minWidth - 10;
            }

            const menuHeight = this.validItems.length * 36 + 10;
            if (top + menuHeight > windowHeight) {
                top = windowHeight - menuHeight - 10;
            }

            this.menuTop = top;
            this.menuLeft = left;
            this.visible = true;
        },

        hideMenu() {
            this.visible = false;
        },

        handleItemClick(item) {
            if (item.disabled) return;

            if (typeof item.handler === 'function') {
                item.handler();
            }

            this.$emit('item-click', item);
            this.hideMenu();
        },

        handleMouseLeave() {
            if (this.closeOnMouseLeave) {
                this.hideMenu();
            }
        }
    }
};
</script>
<style scoped>
.target-wrapper {
    display: inline-block;
}

.context-menu {
    position: fixed;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    padding: 5px 0;
    margin: 0;
    list-style: none;
}

.menu-item {
    padding: 8px 16px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;
    color: #333;
}

.menu-item:hover:not(.disabled):not(.divider) {
    background-color: #f5f5f5;
}

.menu-item.disabled {
    color: #999;
    cursor: not-allowed;
}

.menu-item.divider {
    height: 1px;
    padding: 0;
    margin: 5px 0;
    background-color: #eee;
}
</style>
    